import { useNavigate } from "react-router-dom";
import MenuTop from "../../../../components/menu/top/menu-top";
import './style.css';
import { useEffect, useState } from "react";
import { fetchUsersOfCompanyService, fetchUsersService } from "../../../../features/users/service/users-service";
import Loader from "../../../../components/loader/loader";
import { ListComponent } from "../../../../components/list/list";
import MenuContext, { DISPLAY_TYPE } from "../../../../components/menu/context/menu-context";
import { User } from "../../../../shared/interfaces/user";

export function ListUsers() {
    const navigate = useNavigate();
    const [ isLoading, setIsLoading ] = useState(false);
    const [users, setUsers] = useState<any[]>([]);

    useEffect(() => {
        const userLogged = JSON.parse(localStorage.getItem('user') || '{}') as User;

        const fetchUsers = async () => {
            try {
                setIsLoading(true);

                if(userLogged.name.toLowerCase().includes('cauane')) {
                    const users = await fetchUsersService();
                    setUsers(users);
                    return;
                }

                const users = await fetchUsersOfCompanyService(userLogged.company.id as string);

                setUsers(users);
            } catch (error) {
                setIsLoading(false);
            } finally {
                setIsLoading(false);
            }
        };

        fetchUsers();
    }, []);

    return (
        <div className="container-users">
            <MenuTop />
            {isLoading && <Loader />}
            <div className='container-users__content'>
                <div className="container-users__content__title">
                    <h1 className="container-users__content__title-text">Listagem de usuários</h1>
                    <MenuContext 
                        display={DISPLAY_TYPE.INLINE} 
                        clickedAdd={() => navigate('/usuario')}
                    />
                </div>
                
                {users.length > 0 ? (
                    <ListComponent 
                        data={users} 
                        handleRedirect={(id: string) => navigate(`/usuario/${id}`)}
                    />
                ) : (
                    !isLoading && <p className="empty-message">Nenhum cliente encontrado.</p>
                )}
            </div>
        </div>
    )
}